export default __webpack_public_path__ + "static/char-s-04-kr-0a584ee12cb9878615b5a50057dd0313.png";